module.exports = __webpack_public_path__ + "assets/img/trust_5.9f97060f.png";